export enum LotsFilter {
  All,
  Draft,
  Pending,
}
